import { render, staticRenderFns } from "./DetectionListComponent.vue?vue&type=template&id=6a46a20e&scoped=true&"
import script from "./DetectionListComponent.vue?vue&type=script&lang=js&"
export * from "./DetectionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46a20e",
  null
  
)

export default component.exports